<div class="row">
  <div class="col-md-6">
    <app-project-detail [project]="project"></app-project-detail>
  </div>
  <div class="col-md-6">
    <div class="row">
      <app-project-progress [project]="project"></app-project-progress>
    </div>
    <div class="row">
      <app-project-timeline [project]="project"></app-project-timeline>
    </div>
  </div>
</div>
